import { useTasks } from "../Tasks";

const Empty = ({ today }) => {
  const { todaysTasks, tomorrowsTasks } = useTasks();

  if (
    (today === true && todaysTasks.length === 0) ||
    (today === false && tomorrowsTasks.length === 0)
  ) {
    return (
      <div className="empty">
        <code>No tasks here yet</code>
      </div>
    );
  } else {
    return null;
  }
};

export default Empty;
